import { render } from "./FloatingChatbot.vue?vue&type=template&id=523b8023&scoped=true"
import script from "./FloatingChatbot.vue?vue&type=script&lang=js"
export * from "./FloatingChatbot.vue?vue&type=script&lang=js"

import "./FloatingChatbot.vue?vue&type=style&index=0&id=523b8023&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523b8023"]])

export default __exports__